//9:管理者９が最高管理者
module.exports = {
  surveyCode: {
    10010: '人事評価力診断', //組織診断
    20110: '研修前後アンケート', //マルハニチロさん向け
    20210: 'E3-Survey研修後アンケート',
    30010: 'E3-Survey',
    40010: '360度診断',
    50010: 'モチベーション・トレンド診断', //個人診断
    50020: 'パーソナリティ診断', //個人診断
    50030: 'キャラクター診断', //個人診断
    50040: 'ソーシャルスタイル診断', //個人診断
    60010: 'フォロワーシップ診断', //個人診断→実質利用しない方向
    60020: 'フォロワーシップ診断A・B', //360診断形式、本人、上司、部下 組み合わせ、bsfs:アドバンス、bsfs_basicベーシック
    70010: '女性活躍組織診断', //組織診断
    80010: 'ダイバーシティ組織診断', //組織診断
    90101: '人事評価力診断コース', //9:コース、01:第一カテゴリー、01：連番
    90301: 'E3-Surveyコース', //9:コース、01:第一カテゴリー、01：連番
    90501: 'モチベーション・トレンド診断コース', //9:コース、01:第一カテゴリー、01：連番
    90502: 'パーソナリティ診断コース', //9:コース、01:第一カテゴリー、01：連番
    90503: 'キャラクター診断コース', //9:コース、01:第一カテゴリー、01：連番
    90601: 'フォロワーシップ診断コース', //9:コース、01:第一カテゴリー、01：連番
    99010: 'その他', //9:コース、01:第一カテゴリー、01：連番
  },
};
